import i18n from "i18next";
import { z } from "zod";
import { notificationSchema } from "../utils";
import {
  createActualQuantitySchema,
  createAtcSchema,
  PORT_SERVICE_FIELDS_LANG_BASE,
  withAtcAfterAtsValidation,
} from "./sharedClosePortServiceSchemas";

const LANG_BASE = PORT_SERVICE_FIELDS_LANG_BASE;

const createActualNumberOfSkipsSchema = () =>
  z.object({
    actualNumberOfSkips: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) return undefined;

        const parsed = Number(value);
        return Number.isNaN(parsed) ? value : parsed;
      },
      z.number({
        required_error: i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.actual-number-of-skips`),
        }),
        invalid_type_error: i18n.t("form-validation.invalid-number", {
          label: i18n.t(`${LANG_BASE}.actual-number-of-skips`),
        }),
      }),
    ),
  });

const createGarbageDisposalDocumentFieldsSchema = (isBerth?: boolean) =>
  z.object({
    garbageDisposalDocument: z
      .object({
        documentUrl: z.string().optional(),
        documentName: z.string().optional(),
        fileType: z.string().optional(),
      })
      .optional()
      .superRefine((val, ctx) => {
        const hasDocument = !!val?.documentUrl?.trim();

        if (isBerth && !hasDocument) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t("form-validation.required", {
              label: i18n.t(`${LANG_BASE}.garbage-disposal-document`),
            }),
          });
        }
      }),
  });

export const closeGarbageDisposalSchema = (isBerth?: boolean, ats?: string | Date | null) =>
  withAtcAfterAtsValidation(
    (createAtcSchema("required") as z.AnyZodObject)
      .merge(createActualQuantitySchema())
      .merge(createActualNumberOfSkipsSchema())
      .merge(createGarbageDisposalDocumentFieldsSchema(isBerth))
      .merge(notificationSchema),
    ats,
  );

export type CloseGarbageDisposalSchema = z.infer<ReturnType<typeof closeGarbageDisposalSchema>>;
